import { produce } from "immer";
import {
  GET_WARNINGS,
  GET_WARNINGS_SUCCESS,
  GET_WARNINGS_FAILURE,
  SAVE_WARNING,
  SAVE_WARNING_SUCCESS,
  SAVE_WARNING_FAILURE,
  UPDATE_WARNING,
  UPDATE_WARNING_SUCCESS,
  UPDATE_WARNING_FAILURE,
  DISMISS_WARNING,
  DISMISS_WARNING_SUCCESS,
  DISMISS_WARNING_FAILURE,
  RECORD_SCHEDULE_REVIEW,
  RECORD_SCHEDULE_REVIEW_SUCCESS,
  RECORD_SCHEDULE_REVIEW_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingWarnings: false,
  warnings: [],
  isSavingWarning: false,
  isUpdatingWarning: false,
  isDismissingWarning: false,
  isRecordingScheduleReview: false,
};

const ResidentWarningsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_WARNINGS:
        draft.isFetchingWarnings = true;
        draft.warnings = [];
        break;
      case GET_WARNINGS_SUCCESS:
        draft.isFetchingWarnings = false;
        draft.warnings = action.payload;
        break;
      case GET_WARNINGS_FAILURE:
        draft.warnings = [];
        draft.isFetchingWarnings = false;
        break;
      // Save Template Data
      case SAVE_WARNING:
        draft.isSavingWarning = true;
        break;
      case SAVE_WARNING_SUCCESS:
        draft.isSavingWarning = false;
        break;
      case SAVE_WARNING_FAILURE:
        draft.isSavingWarning = false;
        break;
      // Update Template Data
      case UPDATE_WARNING:
        draft.isUpdatingWarning = true;
        break;
      case UPDATE_WARNING_SUCCESS:
        draft.isUpdatingWarning = false;
        break;
      case UPDATE_WARNING_FAILURE:
        draft.isUpdatingWarning = false;
        break;
      // Dismiss with reason
      case DISMISS_WARNING:
        draft.isDismissingWarning = true;
        break;
      case DISMISS_WARNING_SUCCESS:
        draft.isDismissingWarning = false;
        break;
      case DISMISS_WARNING_FAILURE:
        draft.isDismissingWarning = false;
        break;
      // Record a schedule-review action on an alert
      case RECORD_SCHEDULE_REVIEW:
        draft.isRecordingScheduleReview = true;
        break;
      case RECORD_SCHEDULE_REVIEW_SUCCESS:
      case RECORD_SCHEDULE_REVIEW_FAILURE:
        draft.isRecordingScheduleReview = false;
        break;
      default:
        return state;
    }
  });

export default ResidentWarningsReducer;
